/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Consult_Purchase_DoneInputs */

const en_consult_purchase_done = /** @type {(inputs: Consult_Purchase_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Request sent. If your mail app did not open, write to ${i?.email}.`)
};

const id_consult_purchase_done = /** @type {(inputs: Consult_Purchase_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Permintaan terkirim. Kalau aplikasi email tidak terbuka, tulis ke ${i?.email}.`)
};

/**
* | output |
* | --- |
* | "Request sent. If your mail app did not open, write to {email}." |
*
* @param {Consult_Purchase_DoneInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_purchase_done = /** @type {((inputs: Consult_Purchase_DoneInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Purchase_DoneInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_purchase_done(inputs)
	return en_consult_purchase_done(inputs)
});